import BrandGroup from './BrandGroup';
import Site from './Site';
import Language from './Language';
import Currency from './Currency';
import Country from './Country';
const brands = [
    {
        name: 'Totaljobs',
        siteId: Site.Totaljobs,
        hostPattern: 'www.totaljobs',
        logo: '/account/Images/Totaljobs/icon.min.svg',
        backgroundColor: '#ffffff',
        brandGroup: BrandGroup.Totaljobs,
        liveDomainExtension: '.com',
        defaultLanguage: Language.English,
        availableLanguages: [Language.English],
        currency: Currency.BritishPound,
        country: Country.UnitedKingdom,
        twitterAccount: '@totaljobsUK',
        siteName: 'Totaljobs.com',
    },
    {
        name: 'CareerStructure',
        siteId: Site.CareerStructure,
        hostPattern: 'www.careerstructure',
        logo: '/account/Images/Careerstructure/icon.min.svg',
        backgroundColor: '#306289',
        brandGroup: BrandGroup.Totaljobs,
        liveDomainExtension: '.com',
        defaultLanguage: Language.English,
        availableLanguages: [Language.English],
        currency: Currency.BritishPound,
        country: Country.UnitedKingdom,
        twitterAccount: '@CareerStructure',
        siteName: 'CareerStructure.com',
    },
    {
        name: 'Caterer.com',
        siteId: Site.Caterer,
        hostPattern: 'www.caterer\\.',
        logo: '/account/Images/Caterer/icon.min.svg',
        backgroundColor: '#555555',
        brandGroup: BrandGroup.Totaljobs,
        liveDomainExtension: '.com',
        defaultLanguage: Language.English,
        availableLanguages: [Language.English],
        currency: Currency.BritishPound,
        country: Country.UnitedKingdom,
        twitterAccount: '@Catererdotcom',
        siteName: 'Caterer.com',
    },
    {
        name: 'CatererGlobal',
        siteId: Site.CatererGlobal,
        hostPattern: 'www.catererglobal',
        logo: '/account/Images/CatererGlobal/icon.min.svg',
        backgroundColor: '#ffffff',
        brandGroup: BrandGroup.Totaljobs,
        liveDomainExtension: '.com',
        defaultLanguage: Language.English,
        availableLanguages: [Language.English],
        currency: Currency.BritishPound,
        country: Country.UnitedKingdom,
        twitterAccount: '@Catererglobal',
        siteName: 'CatererGlobal.com',
    },
    {
        name: 'CWjobs',
        siteId: Site.CWJobs,
        hostPattern: 'www.cwjobs',
        logo: '/account/Images/CWJobs/icon.min.svg',
        backgroundColor: '#ffffff',
        brandGroup: BrandGroup.Totaljobs,
        liveDomainExtension: '.co.uk',
        defaultLanguage: Language.English,
        availableLanguages: [Language.English],
        currency: Currency.BritishPound,
        country: Country.UnitedKingdom,
        twitterAccount: '@CWJobsUK',
        siteName: 'CWJobs.co.uk',
    },
    {
        name: 'Milkround',
        siteId: Site.Milkround,
        hostPattern: 'www.milkround',
        logo: '/account/Images/Milkround/icon.min.svg',
        backgroundColor: '#ffffff',
        brandGroup: BrandGroup.Totaljobs,
        liveDomainExtension: '.com',
        defaultLanguage: Language.English,
        availableLanguages: [Language.English],
        currency: Currency.BritishPound,
        country: Country.UnitedKingdom,
        twitterAccount: '@Milkroundonline',
        siteName: 'Milkround.com',
    },
    {
        name: 'RetailChoice',
        siteId: Site.RetailChoice,
        hostPattern: 'www.retailchoice',
        logo: '/account/Images/Retailchoice/icon.min.svg',
        backgroundColor: '#00577c',
        brandGroup: BrandGroup.Totaljobs,
        liveDomainExtension: '.com',
        defaultLanguage: Language.English,
        availableLanguages: [Language.English],
        currency: Currency.BritishPound,
        country: Country.UnitedKingdom,
        twitterAccount: '@RetailChoice',
        siteName: 'RetailChoice.com',
    },
    {
        name: 'Jobsite',
        siteId: Site.Jobsite,
        hostPattern: 'www.jobsite',
        logo: '',
        backgroundColor: '',
        brandGroup: BrandGroup.Jobsite,
        liveDomainExtension: '.co.uk',
        defaultLanguage: Language.English,
        availableLanguages: [Language.English],
        currency: Currency.BritishPound,
        country: Country.UnitedKingdom,
        twitterAccount: '@JobsiteUK',
        siteName: 'Jobsite.co.uk',
    },
    {
        name: 'JustEngineers',
        siteId: Site.JustEngineers,
        hostPattern: 'www.justengineers',
        logo: '',
        backgroundColor: '',
        brandGroup: BrandGroup.Jobsite,
        liveDomainExtension: '.net',
        defaultLanguage: Language.English,
        availableLanguages: [Language.English],
        currency: Currency.BritishPound,
        country: Country.UnitedKingdom,
        twitterAccount: '@JEngineerJobs',
        siteName: 'JustEngineers.net',
    },
    {
        name: 'CityJobs',
        siteId: Site.CityJobs,
        hostPattern: 'www.cityjobs',
        logo: '',
        backgroundColor: '',
        brandGroup: BrandGroup.Jobsite,
        liveDomainExtension: '.com',
        defaultLanguage: Language.English,
        availableLanguages: [Language.English],
        currency: Currency.BritishPound,
        country: Country.UnitedKingdom,
        twitterAccount: '@CityJobsUK',
        siteName: 'Cityjobs.com',
    },
    {
        name: 'emedcareers',
        siteId: Site.EmedCareers,
        hostPattern: 'www.emedcareers',
        logo: '',
        backgroundColor: '',
        brandGroup: BrandGroup.Jobsite,
        liveDomainExtension: '.com',
        defaultLanguage: Language.English,
        availableLanguages: [Language.English],
        currency: Currency.BritishPound,
        country: Country.UnitedKingdom,
        twitterAccount: '@emedcareers',
        siteName: 'Emedcareers.com',
    },
    {
        name: 'stepstonede',
        siteId: Site.StepStoneDE,
        hostPattern: '.stepstone.de',
        logo: '',
        backgroundColor: '',
        brandGroup: BrandGroup.Stepstone,
        liveDomainExtension: '.de',
        defaultLanguage: Language.German,
        availableLanguages: [Language.German, Language.English],
        currency: Currency.Euro,
        country: Country.Germany,
        twitterAccount: '@stepstone_de',
        siteName: 'Stepstone.de',
    },
    {
        name: 'stepstoneat',
        siteId: Site.StepStoneAT,
        hostPattern: '.stepstone.at',
        logo: '',
        backgroundColor: '',
        brandGroup: BrandGroup.Stepstone,
        liveDomainExtension: '.at',
        defaultLanguage: Language.German,
        availableLanguages: [Language.German, Language.English],
        currency: Currency.Euro,
        country: Country.Austria,
        twitterAccount: '@stepstone_at',
        siteName: 'Stepstone.at',
    },
    {
        name: 'stepstonebe',
        siteId: Site.StepStoneBE,
        hostPattern: '.stepstone.be',
        logo: '',
        backgroundColor: '',
        brandGroup: BrandGroup.Stepstone,
        liveDomainExtension: '.be',
        defaultLanguage: Language.Dutch,
        availableLanguages: [Language.Dutch, Language.French, Language.English],
        currency: Currency.Euro,
        country: Country.Belgium,
        twitterAccount: '',
        siteName: 'Stepstone.be',
    },
    {
        name: 'stepstonenl',
        siteId: Site.StepStoneNL,
        hostPattern: '.stepstone.nl',
        logo: '',
        backgroundColor: '',
        brandGroup: BrandGroup.Stepstone,
        liveDomainExtension: '.nl',
        defaultLanguage: Language.Dutch,
        availableLanguages: [Language.Dutch, Language.English],
        currency: Currency.Euro,
        country: Country.Netherlands,
        twitterAccount: '@stepstone_nl',
        siteName: 'Stepstone.nl',
    },
    {
        name: 'pnet',
        siteId: Site.Pnet,
        hostPattern: '.pnet.co.za',
        logo: '',
        backgroundColor: '',
        brandGroup: BrandGroup.Stepstone,
        liveDomainExtension: '.co.za',
        defaultLanguage: Language.English,
        availableLanguages: [Language.English],
        currency: Currency.SouthAfricanRand,
        country: Country.SouthAfrica,
        twitterAccount: '@JobPortal_PNet',
        siteName: 'Pnet.co.za',
    },
    {
        name: 'NIJobs',
        siteId: Site.NIJobs,
        hostPattern: 'www.nijobs',
        logo: '/account/Images/NIJobs/icon.min.svg',
        backgroundColor: '#010101',
        brandGroup: BrandGroup.Saon,
        liveDomainExtension: '.com',
        defaultLanguage: Language.English,
        availableLanguages: [Language.English],
        currency: Currency.BritishPound,
        country: Country.UnitedKingdom,
        twitterAccount: '@NIjobscom',
        siteName: 'Nijobs.com',
    },
    {
        name: 'IrishJobs',
        siteId: Site.IrishJobs,
        hostPattern: 'www.irishjobs',
        logo: '/account/Images/IrishJobs/icon.min.svg',
        backgroundColor: '#010101',
        brandGroup: BrandGroup.Saon,
        liveDomainExtension: '.ie',
        defaultLanguage: Language.English,
        availableLanguages: [Language.English],
        currency: Currency.Euro,
        country: Country.Ireland,
        twitterAccount: '@Irishjobsie',
        siteName: 'Irishjobs.ie',
    },
    {
        name: 'Jobs.ie',
        siteId: Site.Jobsie,
        hostPattern: 'www.jobs',
        devHostPattern: 'www.jobsie',
        logo: '/account/Images/Jobsie/icon.min.svg',
        backgroundColor: '#00263D',
        brandGroup: BrandGroup.Saon,
        liveDomainExtension: '.ie',
        defaultLanguage: Language.English,
        availableLanguages: [Language.English],
        currency: Currency.Euro,
        country: Country.Ireland,
        twitterAccount: '@jobsdotie',
        siteName: 'Jobs.ie',
    },
    {
        name: 'Spiegel',
        siteId: Site.Spiegel,
        hostPattern: 'jobs.spiegel.de',
        logo: '',
        backgroundColor: '',
        brandGroup: BrandGroup.Partners,
        liveDomainExtension: '.de',
        defaultLanguage: Language.German,
        availableLanguages: [Language.German],
        currency: Currency.Euro,
        country: Country.Germany,
        twitterAccount: '@derspiegel',
        siteName: '',
    },
    {
        name: 'Handelsblatt',
        siteId: Site.Handelsblatt,
        hostPattern: 'jobs.handelsblatt.com',
        logo: '',
        backgroundColor: '',
        brandGroup: BrandGroup.Partners,
        liveDomainExtension: '.com',
        defaultLanguage: Language.German,
        availableLanguages: [Language.German],
        currency: Currency.Euro,
        country: Country.Germany,
        twitterAccount: '@handelsblatt',
        siteName: '',
    },
    {
        name: 'Berlin',
        siteId: Site.Berlin,
        hostPattern: 'jobs.berlin.de',
        logo: '',
        backgroundColor: '',
        brandGroup: BrandGroup.Partners,
        liveDomainExtension: '.de',
        defaultLanguage: Language.German,
        availableLanguages: [Language.German],
        currency: Currency.Euro,
        country: Country.Germany,
        twitterAccount: '',
        siteName: '',
    },
    {
        name: 'Welt',
        siteId: Site.Welt,
        hostPattern: 'jobs.welt.de',
        logo: '',
        backgroundColor: '',
        brandGroup: BrandGroup.Partners,
        liveDomainExtension: '.de',
        defaultLanguage: Language.German,
        availableLanguages: [Language.German],
        currency: Currency.Euro,
        country: Country.Germany,
        twitterAccount: 'welt',
        siteName: '',
    },
    {
        name: 'Bild',
        siteId: Site.Bild,
        hostPattern: 'jobs.bild.de',
        logo: '',
        backgroundColor: '',
        brandGroup: BrandGroup.Partners,
        liveDomainExtension: '.de',
        defaultLanguage: Language.German,
        availableLanguages: [Language.German],
        currency: Currency.Euro,
        country: Country.Germany,
        twitterAccount: '',
        siteName: '',
    },
    {
        name: 'Karriere',
        siteId: Site.Karriere,
        hostPattern: 'jobs.karriere.de',
        logo: '',
        backgroundColor: '',
        brandGroup: BrandGroup.Partners,
        liveDomainExtension: '.de',
        defaultLanguage: Language.German,
        availableLanguages: [Language.German],
        currency: Currency.Euro,
        country: Country.Germany,
        twitterAccount: '',
        siteName: '',
    },
    {
        name: 'Studydrive',
        siteId: Site.Studydrive,
        hostPattern: 'studydrive.net',
        logo: '',
        backgroundColor: '',
        brandGroup: BrandGroup.Partners,
        liveDomainExtension: '.net',
        defaultLanguage: Language.English,
        availableLanguages: [Language.English, Language.German],
        currency: Currency.Euro,
        country: Country.Germany,
        twitterAccount: '',
        siteName: '',
    },
    {
        name: 'Job',
        siteId: Site.Job,
        hostPattern: 'job.at',
        logo: '',
        backgroundColor: '',
        brandGroup: BrandGroup.Partners,
        liveDomainExtension: '.at',
        defaultLanguage: Language.English,
        availableLanguages: [Language.English, Language.German],
        currency: Currency.Euro,
        country: Country.Austria,
        twitterAccount: '',
        siteName: '',
    },
    {
        name: 'Unijobs',
        siteId: Site.Unijobs,
        hostPattern: 'unijobs.at',
        logo: '',
        backgroundColor: '',
        brandGroup: BrandGroup.Partners,
        liveDomainExtension: '.at',
        defaultLanguage: Language.German,
        availableLanguages: [Language.German],
        currency: Currency.Euro,
        country: Country.Austria,
        twitterAccount: '@stepstone_at',
        siteName: 'Unijobs.at',
    },
];
export default brands;
//# sourceMappingURL=brands.js.map